import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getOriginMatFile, parseInitProjectData } from 'pxc-editor-web/environment_modules/xcore/helpers/parser';
import { NO_PRINTER_ID } from '@/constants';
import { printers } from '@/helpers/printers';
import { uploadProject } from '@/actions/project';
import { RadioButtonsSelectModal } from '@/components';

const Container = props => {
  const { open, setOpen } = props;
  const printerList = useSelector((state) => state.core.printerList);
  const preselectedPrinter = useSelector((state) => state.core.preselectedPrinter);
  const colorSchema = useSelector((state) => state.core.colorSchema);
  const dispatch = useDispatch();
  const intl = useIntl();
  const filteredPrinters = printers.filter(p => printerList.includes(p.id) || p.id === NO_PRINTER_ID);

  const handleChangePrinter = (printerNumber) => {
    const printer = filteredPrinters.find((l) => l.id === printerNumber);

    if (printer) {
      const originMatFile = getOriginMatFile();
      if (originMatFile) {
        const parsedProjectData = parseInitProjectData({
          material: { name: '-', contents: JSON.stringify(originMatFile), is_base64: false },
          material_selected_article_number: colorSchema?.article_number,
          project_metadata: { preselectedPrinter: printer.id },
        });
  
        dispatch(uploadProject({
          projectData: parsedProjectData,
          beforeFinishActionsClb: () => setOpen(false)
        }));
      }
    }
  };

  if (open) {
    return (
      <RadioButtonsSelectModal
        open
        header={intl.formatMessage({ id: 'core.selectPrinter', defaultMessage: 'Select printer' })}
        list={filteredPrinters?.map(p => ({ value: p.id, label: p.name }))}
        preselect={preselectedPrinter}
        setOpen={setOpen}
        onChange={handleChangePrinter}
      />
    );
  }
  return null;
};

export default Container;
